import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './StandardOverview.module.css';
import { OverviewTextAction } from './OverviewCardShell';
import { OVERVIEW_DUMMY_FIELDS } from './overviewDummyFields';

const SourceMaterialsCard = ({ model }) => {
    const navigate = useNavigate();
    const { sourceMaterials } = model;
    const count = sourceMaterials.length;

    return (
        <section className={styles.sourceMaterialsCard}>
            <div className={styles.sourceMaterialsMain}>
                <p className={styles.cardEyebrow}>Source Materials</p>
                <p className={styles.cardStatus}>
                    {count} document{count === 1 ? '' : 's'} available
                </p>
                {count > 0 ? (
                    <p className={styles.sourceMaterialsFiles}>{sourceMaterials.slice(0, 3).join(' · ')}</p>
                ) : (
                    <p className={styles.cardDescription} title={OVERVIEW_DUMMY_FIELDS.sourceMaterialsFallback}>
                        Upload initial project documents during setup to populate this list.
                    </p>
                )}
            </div>
            {/* <OverviewTextAction onClick={() => navigate('/EditProject')}>View source material →</OverviewTextAction> */}
        </section>
    );
};

export default SourceMaterialsCard;
